import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { CreditCard, Banknote, Wallet } from "lucide-react";

export default function RegistrarPagoDialog({ open, onClose, onSubmit, isLoading }) {
  const [metodoPago, setMetodoPago] = useState("transferencia");

  const handleSubmit = () => {
    onSubmit(metodoPago);
  };

  const metodos = [
    { value: "transferencia", label: "Transferencia bancaria", icon: Banknote },
    { value: "tarjeta", label: "Tarjeta de crédito", icon: CreditCard },
    { value: "efectivo", label: "Efectivo", icon: Wallet },
  ];

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CreditCard className="w-5 h-5 text-green-600" />
            Registrar pago
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <Label className="text-sm text-gray-600 mb-2 block">¿Por dónde has recibido el pago?</Label>
          <div className="space-y-2">
            {metodos.map(({ value, label, icon: Icon }) => (
              <button
                key={value}
                type="button"
                onClick={() => setMetodoPago(value)}
                className={`w-full flex items-center gap-3 p-3 rounded-lg border-2 transition-all ${
                  metodoPago === value
                    ? "border-green-500 bg-green-50 dark:bg-green-950"
                    : "border-gray-200 dark:border-gray-700 hover:border-gray-300"
                }`}
              >
                <Icon className={`w-5 h-5 ${metodoPago === value ? "text-green-600" : "text-gray-400"}`} />
                <span className={`font-medium ${metodoPago === value ? "text-green-700 dark:text-green-300" : "text-gray-700 dark:text-gray-300"}`}>
                  {label}
                </span>
              </button>
            ))}
          </div>
        </div>

        <DialogFooter className="flex gap-2">
          <Button variant="outline" onClick={onClose}>
            Cancelar
          </Button>
          <Button 
            onClick={handleSubmit} 
            disabled={isLoading}
            className="bg-green-600 hover:bg-green-700"
          >
            {isLoading ? "Guardando..." : "Confirmar pago"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}